// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Odb7i","container":"styles_container__2olL3","title":"styles_title__3J2Kn","wrapper":"styles_wrapper__73OYT","answer":"styles_answer__2LDJK"};